/**
 * Başkalarına gösterilen isim: tam ad asla çıkmaz, soyadın yalnızca baş harfi görünür.
 * "Necmiye Ortaköy" → "Necmiye O." · "Ayşe Nur Yılmaz" → "Ayşe Nur Y." · tek sözcük olduğu gibi kalır.
 * Zaten maskeli ("Necmiye O.") ya da e-posta öneki gibi tek parça isimlere dokunmaz (idempotent).
 * functions/src/publicName.ts ile aynı olmalı.
 */
export function toPublicName(name: unknown): string {
    const raw = typeof name === 'string' ? name.trim().replace(/\s+/g, ' ') : '';
    if (!raw) return '';
    const parts = raw.split(' ');
    if (parts.length < 2) return raw;
    const last = parts[parts.length - 1];
    if (/^\p{L}\.?$/u.test(last)) return `${parts.slice(0, -1).join(' ')} ${last.charAt(0).toLocaleUpperCase('tr-TR')}.`;
    return `${parts.slice(0, -1).join(' ')} ${Array.from(last)[0].toLocaleUpperCase('tr-TR')}.`;
}
